
const service = (apiInstance) => {
  apiInstance.interceptors.request.use(
    (config) => {
      //const token = localStorage.getItem("token");
      //if (token) config.headers.Authorization = `Bearer ${token}`;
      return config;
    },
    (error) => Promise.reject(error)
  );

  apiInstance.interceptors.response.use(
    (response) => response,
    (error) => Promise.reject(error)
  );

  return apiInstance;
};

export default service;